module.exports = function mixin(to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/dpapp/lib/util/mixin.js
// module id = 168
// module chunks = 10 11 12 13 14 15 16 17 18 19